import C, { ref as w, computed as L, onMounted as D, onUnmounted as M, nextTick as R, useSlots as q, h as T } from "vue";
function U({
  source: e,
  contentGroup: t,
  test: n,
  placementGroup: o,
  deliveryLifeTimeMinutes: i,
  equallyDistributed: r,
  trackEvent: a,
  goalId: s,
  queryParameters: l
}) {
  this.source = e, this.contentGroup = t, this.test = n, this.placementGroup = o, this.deliveryLifeTimeMinutes = i, this.equallyDistributed = r, this.trackEvent = a, this.goalId = s, this.queryParameters = l;
}
let u, E, I = () => {
};
const _ = function(e) {
  I = e;
}, x = async function() {
  typeof window._paq != "object" && (window._paq = []), await import("./matomo.d9bf9893.js");
}, v = async function(e = {}) {
  await x(), await V(e);
}, V = async function(e = {}) {
  var t;
  window.EPCDConf = E = (t = window.EPCDConf) != null ? t : e, window.EPCT = u = (await import("./epct.c13a6462.js")).default, u.init(), I();
}, O = function(e) {
  if (e.optOut) {
    u.optOut();
    return;
  }
  const t = e.deliveryInformation.queryParameters.filter((o) => o.parameter.type === "QUERY_PARAMETER").map((o) => `${o.parameter.key}=${encodeURIComponent(o.value)}`).join("&"), n = new U({
    source: e.source,
    contentGroup: e.contentGroup,
    placementGroup: e.layout,
    test: e.test,
    deliveryLifeTimeMinutes: e.deliveryLifeTimeMinutes,
    equallyDistributed: e.equallyDistributed,
    trackEvent: [],
    goalId: null,
    queryParameters: new URLSearchParams(t)
  });
  if (E.isConsentGivenOrNotRequired() && u) {
    u.updateCustomVars(n);
    const o = u.getAdtTrackingParametersAsQueryString(n.equallyDistributed);
    u.pTracker.appendToTrackingUrl(o);
    const i = n.queryParameters.toString();
    i && u.pTracker.setCustomUrl(`${window.location.origin}${window.location.pathname}?${i}`), n && n.source && n.contentGroup && n.placementGroup && n.test && (u.track(), i && u.pTracker.setCustomUrl(window.location.href));
  } else
    P(n);
}, P = function(e) {
  u.configsToTrackAfterConsentIsGiven.push(e);
}, H = function() {
  return u;
};
function $({
  piwikSiteId: e,
  test: t,
  source: n,
  contentGroup: o,
  layout: i,
  benchmark: r,
  equallyDistributed: a,
  contentObject: s,
  optOut: l,
  deliveryLifeTimeMinutes: h,
  deliveryInformation: f
}) {
  this.piwikSiteId = e, this.test = t, this.source = n, this.contentGroup = o, this.layout = i, this.benchmark = r, this.equallyDistributed = a, this.contentObject = s, this.optOut = l, this.deliveryLifeTimeMinutes = h, this.deliveryInformation = f;
}
function N({
  projectId: e,
  hideOnStart: t,
  pathnames: n,
  strict: o,
  projectParameters: i,
  getElementsToHide: r
}) {
  this.projectId = e, this.hideOnStart = t, this.pathnames = n, this.strict = o, this.projectParameters = i, this.getElementsToHide = r;
}
function A({
  isConsentRequired: e,
  companyId: t,
  pageId: n,
  service: o,
  epcAnalyticsLocation: i,
  epcAnalyticsEndpoint: r,
  hideOnStartTimeout: a,
  analyticsSiteId: s,
  enableSecureCookies: l,
  nonAnalyticsCookies: h,
  isConsentGivenOrNotRequired: f,
  appParentElementSelector: c,
  toolbarClientLocation: m,
  toolbarLocation: d
}) {
  this.isConsentRequired = e, this.companyId = t, this.pageId = n, this.service = o, this.epcAnalyticsLocation = i, this.epcAnalyticsEndpoint = r, this.hideOnStartTimeout = a, this.analyticsSiteId = s, this.enableSecureCookies = l, this.nonAnalyticsCookies = h, this.isConsentGivenOrNotRequired = f, this.appParentElementSelector = c, this.toolbarClientLocation = m, this.toolbarLocation = d;
}
const B = function() {
  const e = [
    "APIs-Google",
    "AdsBot-Google-Mobile",
    "AdsBot-Google",
    "Mediapartners-Google",
    "Googlebot-Image",
    "Googlebot-News",
    "Googlebot",
    "Googlebot-Video",
    "Mediapartners-Google",
    "AdsBot-Google-Mobile-Apps",
    "FeedFetcher-Google",
    "Google-Read-Aloud",
    "DuplexWeb-Google",
    "googleweblight",
    "Storebot-Google",
    "Google-Site-Verification"
  ], t = navigator.userAgent;
  return e.some((n) => t.includes(n));
};
let p;
const S = function(e = !1, t = 1500) {
  !e || (document.documentElement.style.visibility = t ? "hidden" : "visible", p && clearTimeout(p), p = setTimeout(function() {
    document.documentElement.style.visibility = "visible";
  }, t));
}, g = function(e) {
  const t = document.readyState;
  t === "interactive" || t === "complete" ? e() : document.addEventListener("DOMContentLoaded", e);
}, F = function() {
  const e = window.location.hash.match(/domDef=([0-9]*)/);
  if (e)
    return e[1];
  const t = b("adt_domdef");
  if (t) {
    const n = t.match(/^[0-9]*$/);
    if (n)
      return n[0] || null;
  }
  return null;
}, ie = function(e) {
  let t = null;
  for (const n of e)
    n.pathnames.forEach((o) => {
      if (!n.strict && window.location.pathname.includes(o) || n.strict && window.location.pathname === o)
        return t = n, !1;
    });
  return t;
};
function j() {
  return window.location.toString();
}
const Q = function() {
  const e = new URLSearchParams();
  return e.set("_adt_device", ""), e.set("_adt_day", X()), e.set("_adt_time", z()), e;
}, W = function(e = "div") {
  const t = document.createElement("div");
  t.id = "adtelligence-app";
  const n = document.querySelector(e);
  n.parentNode.insertBefore(t, n.nextSibling);
}, J = function(e, t, n, o, i, r = new URLSearchParams()) {
  let a = new URLSearchParams();
  const s = F();
  s && a.set("domDef", s), a.set("ref", j()), a = new URLSearchParams([
    ...Array.from(a.entries()),
    ...Array.from(Q().entries()),
    ...Array.from(r.entries()),
    ...Array.from(Y(n, i).entries())
  ]), a.set("time", K(new Date(Date.now())));
  const l = window.location.search ? `${window.location.search}&${a.toString()}` : `?${a.toString()}`;
  return `${e}`.includes("https://") || `${e}`.includes("http://") ? `${e}/${t}/${o}${l}` : `${window.location.origin}${e}/${t}/${o}${l}`;
}, re = function(e) {
  return new URLSearchParams(window.location.search).get(e);
}, X = function() {
  const t = new Date(Date.now()).getDay();
  return t === 6 || t === 0 ? "weekend" : "weekday";
}, z = function() {
  const t = new Date(Date.now()).getHours();
  return t >= 0 && t <= 5 ? "night" : t >= 6 && t <= 11 ? "morning" : t >= 12 && t <= 17 ? "afternoon" : "evening";
}, K = function(e) {
  return `${`0${e.getHours()}`.slice(-2)}:${`0${e.getMinutes()}`.slice(-2)}:${`0${e.getSeconds()}`.slice(-2)}`;
}, Y = function(e, t) {
  var r;
  const n = new URLSearchParams(), o = decodeURIComponent((r = b(`_adt_delivery.${e}.${t}`)) != null ? r : ""), i = new RegExp(/(\[\d+:\d+:\d+:\d+])/);
  if (o) {
    const a = o.match(i);
    if (a.length > 0) {
      const s = a[0].slice(1, -1).split(":");
      n.set("source", s[1]), n.set("test", s[2]), n.set("contentGroup", s[3]);
    }
  }
  return n;
}, Z = function(e) {
  for (let t = 0, n = e.length; t < n; t++)
    e[t].classList.add("adt-hidden");
}, b = function(e) {
  const t = document.cookie.match(`(^|;) ?${e}=([^;]*)(;|$)`);
  return t ? t[2] : null;
}, ee = async function(e = new $({}), t = new N({}), n, o = new A({}), i = new G({})) {
  if (n) {
    await v(o), O(e);
    const r = e.contentGroup;
    t && typeof t.getElementsToHide == "function" && Z(t == null ? void 0 : t.getElementsToHide(r)), W(o.appParentElementSelector), new C({
      render: (a) => a(n, {
        props: {
          componentKey: r,
          vueIntegrationLibrary: i,
          projectConfig: t
        }
      })
    }).$mount("#adtelligence-app");
  }
}, te = function() {
  return window.location.hash.includes("edit-variation") || window.location.hash.includes("edit-project");
}, ne = function(e, t) {
  return window.EPCDConf = window.EPCDConf || {}, window.EPCDConf.cxResponse = t, window.EPCDConf.service = e.service, window.EPCDConf.toolbarLocation = e.toolbarLocation, k(`${e.toolbarClientLocation}webcomponents-bundle.js`).then(
    () => k(`${e.toolbarClientLocation}main.js`)
  );
}, k = function(e) {
  return new Promise((t, n) => {
    const o = document.createElement("script");
    o.type = "text/javascript", o.src = e, o.async = !0, o.onerror = function(i) {
      n(i, o.src);
    }, o.onload = function() {
      t();
    }, document.head.appendChild(o);
  });
};
function G(e = new A({}), t, n, o = () => {
}) {
  let i, r = null;
  if (!(this instanceof G))
    throw new Error("VueIntegrationLibrary is a constructor and should be called with the `new` keyword");
  const a = this;
  b("adt_opt_out") !== "true" && !B() && (t ? (S(t.hideOnStart, e.hideOnStartTimeout), i = J(
    e.service.toString(),
    e.companyId,
    e.analyticsSiteId,
    e.pageId,
    t.projectId,
    t.projectParameters
  ), fetch(i).then((s) => {
    if (s.ok)
      return s.json();
    throw new Error(`No response: ${i}`);
  }).then((s) => {
    g(async function() {
      r = new $({ ...s }), await ee(r, t, n, e, a), te() && await ne(e, r);
    });
  }).catch((s) => {
    throw S(t.hideOnStart, 0), g(async function() {
      await v(e);
    }), s;
  })) : g(async function() {
    await v(e), o(a);
  })), this.getTrackingInstance = function() {
    return H();
  }, this.addConfigToTrackAfterConsentIsGiven = P, this.setAfterMatomoIsLoadedCallback = _, this.getDeliveryUrl = function() {
    return i;
  }, this.getCxResponse = function() {
    return r;
  };
}
const ae = {
  props: {
    initialMods: {
      type: Array,
      default: () => []
    },
    modName: {
      type: String
    },
    modificationGroup: {
      type: String
    },
    internalId: {
      type: String,
      required: !0
    },
    elementId: {
      type: String
    },
    elementClass: {
      type: String
    },
    tagName: {
      type: String,
      default: "div"
    },
    attrValue: {
      type: Object
    },
    htmlValue: {
      type: String,
      default: ""
    },
    overlaySelector: {
      type: String
    },
    modType: {
      type: String,
      default: "editinnerhtml"
    },
    allowedAttributeMods: {
      type: Array,
      default: () => []
    },
    allowedStyleMods: {
      type: Array,
      default: () => []
    }
  },
  setup(e, t) {
    const n = e.initialMods.find((c) => c.internalId === e.internalId), o = w(n ? n.value : e.htmlValue), i = w(n ? n.type : null), r = w(n ? n.explicitHidden : !1), a = L(() => `adt-exec-mod-${e.internalId}`);
    D(() => document.addEventListener(a.value, l)), M(() => {
      document.removeEventListener(a.value, l);
    });
    const s = w(), l = ({ detail: c }) => {
      o.value = c.mod.value, i.value = c.mod.type, r.value = c.mod.explicitHidden, R(() => c.callback(s.value));
    }, h = (c, m) => T(
      e.tagName,
      {
        class: [e.elementClass, "adt-easy-editor-mod"],
        attrs: {
          ...c,
          id: e.elementId
        },
        ref: s
      },
      m.default({})
    ), f = (c, m) => T(e.tagName, {
      class: [e.elementClass, "adt-easy-editor-mod"],
      attrs: {
        ...c,
        id: e.elementId
      },
      domProps: {
        innerHTML: m.html ? m.html : e.htmlValue
      },
      ref: s
    });
    return t.expose({ onMod: l, explicitHidden: r }), () => {
      const c = q(), m = [];
      let d = {
        style: r.value ? "display:none !important;" : "",
        html: ""
      };
      switch (e.modType) {
        case "css":
          d.style += o.value;
          break;
        case "editattr":
          d = { ...d, ...e.attrValue, ...o.value }, delete d.nodename;
          break;
        case "editinnerhtml":
        default:
          d = { ...d, ...e.attrValue }, d.html = o.value;
          break;
      }
      const y = { ...d };
      return delete y.html, y.style || delete y.style, c.default && d.html === "" ? m.push(h(y, c)) : m.push(f(y, d)), m;
    };
  }
};
export {
  A as CXConfiguration,
  $ as CXJsonResponse,
  U as ConfigToTrack,
  g as DOMReady,
  ae as EasyEditorMod,
  N as ProjectConfig,
  G as VueIntegrationLibrary,
  ie as getComponentFromLocation,
  b as getCookie,
  re as getParameterFromURL,
  Y as getQueryForDeliveryHistoryByProjectId,
  S as setPageVisibleAfterTimeout
};
